export default __webpack_public_path__ + "static/media/07_Foxconn.f973de04.png";